<div [innerHTML]="data.message"></div>
<div class="text-right mt-2">
  <button
      *ngFor="let action of data.actions"
      mat-button
      (click)="handle(action)"
      [color]="action.color || 'accent'"
  >{{ action.label }}</button>
</div>
